import {BaseDTO} from '../../common/models/BaseDTO';
import {NameValueDTO} from '../../common/models/NameValueDTO';

export class AssessmentNarrativeDTO extends BaseDTO {
  assessmentNarrativeId: number;
  assessmentActionId: number;
  assessmentActionDescription: string;
  activityId: number;
  referenceClaimId: number;
  referenceEncounterId: number;
  referenceActivityId: number;
  assessmentNarrativeType: NameValueDTO;
}
